import { AbstractBoardLane } from './abstract-board-lane.model';

export class NewRouteBoardLane extends AbstractBoardLane {}
